import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ui-not-valid-page',
  templateUrl: './not-valid-page.component.html',
  styleUrls: ['./not-valid-page.component.less']
})
export class NotValidPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
